import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';

type Props = {
    softwares: string[];
    value: string[];
    onChange: (softwares: string[]) => void;
    label: string;
    placeholder?: string;
    disabled?: boolean;
};

const MultiSoftwareSelector = ({
    softwares,
    value,
    onChange,
    label,
    placeholder = undefined,
    disabled = false,
}: Props) => (
    <Autocomplete
        multiple
        size="small"
        options={softwares}
        value={value}
        onChange={(_event, newValue) => onChange(newValue)}
        renderTags={(tagValue, getTagProps) =>
            tagValue.map((option, index) => (
                <Chip
                    label={option}
                    size="small"
                    variant="outlined"
                    {...getTagProps({ index })}
                    key={option}
                />
            ))
        }
        renderInput={(params) => (
            <TextField
                {...params}
                label={label}
                variant="outlined"
                size="small"
                placeholder={value.length === 0 ? placeholder : undefined}
                sx={{ minWidth: 220 }}
            />
        )}
        sx={{ minWidth: 220 }}
        disableCloseOnSelect
        disabled={disabled}
    />
);

export default MultiSoftwareSelector;
